<script setup>
import { inject, ref, reactive, computed, defineProps } from 'vue';

// Node Modules
import axios from 'axios';

// Vue Components
import NewsCategories from './NewsCategories.vue';
import Loading from './Loading.vue';

// Functions
import getNewsCategories from '../functions/getNewsCategories.js';
import dateFormat from '../functions/dateFormat.js';

const mq = inject(['mq']);

const props = defineProps({
    rootPath: {
        type: String,
        default: ''
    },
});

// リアクティブデータの定義
const taxonomy = ref('news_cat'); //カテゴリ名
const categories = ref([]); //カテゴリ一覧
const post = reactive({}); //記事情報
const errorFlug = ref(false); //エラーかどうか
const done = ref(false); //全ての処理が終わったかどうか

// URLからスラッグを抽出
const slug = computed(() => {
    // return '%e3%83%86%e3%82%b9%e3%83%88%e6%8a%95%e7%a8%bf2'; //ローカルテスト用
    const url = new URL(window.location.href); //URLを取得
    const pathArray = url.pathname.split('/').filter(Boolean); // スラッシュ区切りで配列に格納
    return pathArray[pathArray.length-1]; //最後の要素を返す
});

const getPost = () => {
    // WP REST APIのURL
    const url = `${props.rootPath}/wp-json/wp/custom/posts_by_slug`;

    // パラメータ
    const config = {
        params: {
            post_type: 'news',
            slug: slug.value,
            taxonomy: taxonomy.value,
        }
    };

    // WP REST APIにアクセス
    axios.get(url, config).then(res => {
        Object.assign(post, res.data); //記事情報を格納
        done.value = true;
        // console.log(post);
        
    }).catch(error => {
        errorFlug.value = true;
        done.value = true;
        console.log(error);
    });
}

categories.value = await getNewsCategories(props.rootPath, taxonomy.value);
getPost();
</script>

<template>
<!-- sec -->
<section class="sec is-detail wow animate__fadeIn" v-if="done">
    <div class="inner is-small">
        <div class="sec__area">
            <NewsCategories v-if="mq.mdPlus" :categories="categories"/>
    
            <!-- detail -->
            <div class="detail" v-if="!errorFlug">
                <div class="detail__head">
                    <div class="news-data">
                        <span class="news-data__date">{{ dateFormat(post.date, 'YYYY.MM.DD') }}</span>
                        <a v-if="post.terms[0]" :href="`/news/?category=${post.terms[0].slug}`" class="news-data__cat">
                            {{ post.terms[0].name }}
                        </a>
                    </div>
                    <h1 class="detail__tit">{{ post.title }}</h1>
                </div>
                <div class="wysiwyg detail__body" v-html="post.content"></div>
            </div><!-- ./detail -->
            <p v-else>読み込みに失敗しました。</p>
        </div>

        <!-- pagination -->
        <div class="pagination">
            <a v-if="post.prev_link" :href="post.prev_link" class="pagination__arrow">
                <div class="arrow is-b is-back"></div>
            </a>
            <a href="/news/" class="pagination__link">一覧へもどる</a>
            <a v-if="post.next_link" :href="post.next_link" class="pagination__arrow">
                <div class="arrow is-b"></div>
            </a>
        </div><!-- ./pagination -->

    </div>
</section><!-- ./sec -->
<Loading v-else/>
</template>